const currentDomain = window.location.origin
const checkDom = (domain, code) => {
  if(currentDomain === domain) {
    return code
  }
}
export default checkDom;